import HoverEffectContainer from "../../../../Components/Miscellaneous/Gallery/HoverEffect/HoverEffect"

const HoverEffect = () => {
  return (
    <div className='page-body'>
      <HoverEffectContainer />
    </div>
  )
}

export default HoverEffect